import { contrastRatio, HSLColor } from '@yola/yola-palette-generator';
import findColorShadeInPalette from './find-color-shade-in-palette';
import emitFallbackWarning from './emit-fallback-warning';
import findBiggestShade from './find-biggest-shade';
import findSmallestShade from './find-smallest-shade';

/**
 * condition: Function - conditions for exit from the algorithm
 * initialShade: String - shade value for the start position in the loop
 * isReduce: Boolean - to enable reduce mode
 */

const changeColorPointByRatio = (
  { targetColor, backgroundColor, targetColorPalette, condition, fallback },
  initialShade,
  isReduce
) => {
  const { hue, saturation, lightness, alpha } = targetColor;
  const colorInstance = new HSLColor(hue, saturation, lightness, alpha);
  const ratio = contrastRatio(backgroundColor, colorInstance);

  if (condition(ratio)) return colorInstance;

  const colorShade = initialShade || findColorShadeInPalette(colorInstance, targetColorPalette);

  const shades = Object.keys(targetColorPalette);
  if (isReduce) {
    shades.reverse();
  }

  const shadeInArray = shades.indexOf(colorShade);

  if (shadeInArray >= 0) {
    for (let i = shadeInArray; i < shades.length; i += 1) {
      const key = shades[i];

      const paletteColor = targetColorPalette[key];

      if (condition(contrastRatio(backgroundColor, paletteColor))) {
        return paletteColor;
      }
    }
  }

  emitFallbackWarning(
    `Cannot ${
      isReduce ? 'reduce' : 'increase'
    } color point to reach proper contrast ratio between hsl(${targetColor.toColorString()}) and background color hsl(${backgroundColor.toColorString()})`,
    fallback
  );

  const fallbackShade = isReduce
    ? findSmallestShade(targetColorPalette)
    : findBiggestShade(targetColorPalette);
  return targetColorPalette[fallbackShade];
};

export default changeColorPointByRatio;
